(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elvezen-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elvezen-before-after')) {
    class ElvezenBeforeAfter extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('.elvezen-before-after__frame');
        this.range = this.querySelector('[data-before-after-range]');

        if (!this.frame || !this.range) return;

        this.abortController = new AbortController();

        // The starting position is set in CSS, so this only runs when the visitor drags.
        // Updates are batched to one per frame and scoped to the frame element.
        this.range.addEventListener('input', () => {
          cancelAnimationFrame(this.frameRequest);
          this.frameRequest = requestAnimationFrame(() => {
            this.frame.style.setProperty('--eba-position', `${this.range.value}%`);
          });
        }, { signal: this.abortController.signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        cancelAnimationFrame(this.frameRequest);
      }
    }

    customElements.define('elvezen-before-after', ElvezenBeforeAfter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvezen-collection-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elvezen-collection-slider')) {
    class ElvezenCollectionSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-collection-viewport]');
        this.cards = Array.from(this.querySelectorAll('[data-collection-card]'));
        this.status = this.querySelector('[data-collection-status]');

        const section = this.closest('.shopify-section');
        this.previousButton = section?.querySelector('[data-collection-previous]');
        this.nextButton = section?.querySelector('[data-collection-next]');

        if (!this.viewport || this.cards.length === 0) return;

        this.atStart = true;
        this.atEnd = true;
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.previousButton?.addEventListener('click', () => this.scrollSlider(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.scrollSlider(1), { signal });

        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.scrollSlider(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.scrollSlider(1);
          }
        }, { signal });

        // Arrow state comes from whether the first/last card is in view,
        // so no scroll or resize listeners are needed.
        const first = this.cards[0];
        const last = this.cards[this.cards.length - 1];

        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.target === first) this.atStart = entry.isIntersecting;
            if (entry.target === last) this.atEnd = entry.isIntersecting;
          }
          this.updateControls();
        }, { root: this.viewport, threshold: 0.95 });

        this.observer.observe(first);
        if (last !== first) this.observer.observe(last);

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const card = event.target.closest('[data-collection-card]');
            if (card && this.contains(card)) {
              card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
          }, { signal });
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
      }

      scrollSlider(direction) {
        const gap = parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
        const step = this.cards[0].getBoundingClientRect().width + gap;

        // 'auto' defers to CSS scroll-behavior, so reduced-motion users get no animation
        this.viewport.scrollBy({ left: direction * step, behavior: 'auto' });

        if ('onscrollend' in window) {
          this.viewport.addEventListener('scrollend', () => this.announcePosition(), { once: true });
        } else {
          setTimeout(() => this.announcePosition(), 450);
        }
      }

      updateControls() {
        if (!this.previousButton || !this.nextButton) return;

        this.previousButton.disabled = this.atStart;
        this.nextButton.disabled = this.atEnd;

        const fits = this.atStart && this.atEnd;
        this.previousButton.hidden = fits;
        this.nextButton.hidden = fits;
      }

      announcePosition() {
        if (!this.status) return;

        const viewportLeft = this.viewport.getBoundingClientRect().left;
        let nearestIndex = 0;
        let nearestDistance = Infinity;

        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - viewportLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        this.status.textContent = `Collection ${nearestIndex + 1} of ${this.cards.length}`;
      }
    }

    customElements.define('elvezen-collection-slider', ElvezenCollectionSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvezen-faqs"] && !Shopify.designMode) return;
  try {
    
  // Modern browsers close other FAQs natively via <details name="...">.
  // This fallback only runs in browsers that don't support the name attribute.
  if (!('name' in HTMLDetailsElement.prototype)) {
    // 'toggle' doesn't bubble, so listen in the capture phase
    document.addEventListener('toggle', (event) => {
      const item = event.target;
      if (!(item instanceof HTMLDetailsElement) || !item.open) return;

      const group = item.getAttribute('name');
      if (!group) return;

      document.querySelectorAll(`details[name="${CSS.escape(group)}"][open]`).forEach((other) => {
        if (other !== item) other.open = false;
      });
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvezen-featured-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elvezen-featured-products-slider')) {
    class ElvezenFeaturedProductsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-featured-track]');
        this.cards = Array.from(this.querySelectorAll('[data-featured-card]'));
        this.status = this.querySelector('[data-featured-status]');

        const section = this.closest('.shopify-section');
        this.previousButton = section?.querySelector('[data-featured-previous]');
        this.nextButton = section?.querySelector('[data-featured-next]');

        if (!this.track || this.cards.length === 0) return;

        this.atStart = true;
        this.atEnd = true;
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.previousButton?.addEventListener('click', () => this.scrollSlider(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.scrollSlider(1), { signal });

        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.scrollSlider(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.scrollSlider(1);
          }
        }, { signal });

        // Arrow state comes from whether the first/last card is in view,
        // so no scroll or resize listeners are needed.
        const first = this.cards[0];
        const last = this.cards[this.cards.length - 1];

        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.target === first) this.atStart = entry.isIntersecting;
            if (entry.target === last) this.atEnd = entry.isIntersecting;
          }
          this.updateControls();
        }, { root: this.track, threshold: 0.95 });

        this.observer.observe(first);
        if (last !== first) this.observer.observe(last);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
      }

      scrollSlider(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = this.cards[0].getBoundingClientRect().width + gap;

        // 'auto' defers to CSS scroll-behavior, so reduced-motion users get no animation
        this.track.scrollBy({ left: direction * step, behavior: 'auto' });

        if ('onscrollend' in window) {
          this.track.addEventListener('scrollend', () => this.announcePosition(), { once: true });
        } else {
          setTimeout(() => this.announcePosition(), 450);
        }
      }

      updateControls() {
        if (!this.previousButton || !this.nextButton) return;

        this.previousButton.disabled = this.atStart;
        this.nextButton.disabled = this.atEnd;

        const fits = this.atStart && this.atEnd;
        this.previousButton.hidden = fits;
        this.nextButton.hidden = fits;
      }

      announcePosition() {
        if (!this.status) return;

        const trackLeft = this.track.getBoundingClientRect().left;
        let nearestIndex = 0;
        let nearestDistance = Infinity;

        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        this.status.textContent = `Product ${nearestIndex + 1} of ${this.cards.length}`;
      }
    }

    customElements.define('elvezen-featured-products-slider', ElvezenFeaturedProductsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvezen-trending-product"] && !Shopify.designMode) return;
  try {
    
  // One delegated listener serves every instance of the section,
  // and keeps working after the theme editor re-renders it.
  document.addEventListener('change', (event) => {
    const select = event.target instanceof Element ? event.target.closest('[data-trending-variant-select]') : null;
    if (!select) return;

    const root = select.closest('.elvezen-trending-product');
    if (!root) return;

    const option = select.options[select.selectedIndex];
    const price = option.dataset.price || '';
    const comparePrice = option.dataset.comparePrice || '';
    const available = option.dataset.available === 'true';

    const priceElement = root.querySelector('[data-trending-price]');
    const comparePriceElement = root.querySelector('[data-trending-compare-price]');
    const addButton = root.querySelector('[data-trending-add-button]');
    const buttonText = root.querySelector('[data-trending-button-text]');

    if (priceElement) {
      priceElement.textContent = price;
      priceElement.classList.toggle('is-sale', comparePrice !== '');
    }

    if (comparePriceElement) comparePriceElement.textContent = comparePrice;

    if (addButton) {
      addButton.disabled = !available;
      if (buttonText) buttonText.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvizen-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elvizen-reviews-slider')) {
    class ElvizenReviewsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
        this.status = this.querySelector('[data-review-status]');

        const section = this.closest('.shopify-section');
        this.previousButton = section?.querySelector('[data-review-previous]');
        this.nextButton = section?.querySelector('[data-review-next]');

        if (!this.track || this.cards.length === 0) return;

        this.atStart = true;
        this.atEnd = true;
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.previousButton?.addEventListener('click', () => this.scrollSlider(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.scrollSlider(1), { signal });

        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.scrollSlider(-1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.scrollSlider(1);
          }
        }, { signal });

        // Arrow state comes from whether the first/last card is in view,
        // so no scroll or resize listeners are needed.
        const first = this.cards[0];
        const last = this.cards[this.cards.length - 1];

        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.target === first) this.atStart = entry.isIntersecting;
            if (entry.target === last) this.atEnd = entry.isIntersecting;
          }
          this.updateControls();
        }, { root: this.track, threshold: 0.95 });

        this.observer.observe(first);
        if (last !== first) this.observer.observe(last);

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const card = event.target.closest('[data-review-card]');
            if (card && this.contains(card)) {
              card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
          }, { signal });
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
      }

      scrollSlider(direction) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = this.cards[0].getBoundingClientRect().width + gap;

        // 'auto' defers to CSS scroll-behavior, so reduced-motion users get no animation
        this.track.scrollBy({ left: direction * step, behavior: 'auto' });

        if ('onscrollend' in window) {
          this.track.addEventListener('scrollend', () => this.announcePosition(), { once: true });
        } else {
          setTimeout(() => this.announcePosition(), 450);
        }
      }

      updateControls() {
        if (!this.previousButton || !this.nextButton) return;

        this.previousButton.disabled = this.atStart;
        this.nextButton.disabled = this.atEnd;

        const fits = this.atStart && this.atEnd;
        this.previousButton.hidden = fits;
        this.nextButton.hidden = fits;
      }

      announcePosition() {
        if (!this.status) return;

        const trackLeft = this.track.getBoundingClientRect().left;
        let nearestIndex = 0;
        let nearestDistance = Infinity;

        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        this.status.textContent = `Review ${nearestIndex + 1} of ${this.cards.length}`;
      }
    }

    customElements.define('elvizen-reviews-slider', ElvizenReviewsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elvezen-header')) {
    class ElvezenHeader extends HTMLElement {
      connectedCallback() {
        this.header = this.querySelector('.elvezen-header');
        this.drawer = this.querySelector('[data-mobile-drawer]');
        this.overlay = this.querySelector('[data-mobile-overlay]');
        this.menuOpenButton = this.querySelector('[data-mobile-menu-open]');
        this.menuCloseButton = this.querySelector('[data-mobile-menu-close]');
        this.searchToggle = this.querySelector('[data-search-toggle]');
        this.searchPanel = this.querySelector('[data-search-panel]');
        this.searchInput = this.querySelector('[data-search-input]');
        this.searchClose = this.querySelector('[data-search-close]');

        if (!this.header) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.menuOpenButton?.addEventListener('click', () => this.openDrawer(), { signal });
        this.menuCloseButton?.addEventListener('click', () => this.closeDrawer(), { signal });
        this.overlay?.addEventListener('click', () => this.closeDrawer(), { signal });

        this.searchToggle?.addEventListener('click', () => {
          if (this.searchPanel?.hidden) this.openSearch();
          else this.closeSearch();
        }, { signal });

        this.searchClose?.addEventListener('click', () => this.closeSearch(), { signal });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            const drawerWasOpen = this.drawer?.classList.contains('is-open');
            this.closeDrawer(drawerWasOpen);
            this.closeSearch();
            this.closeDropdowns();
          } else if (event.key === 'Tab') {
            this.trapFocus(event);
          }
        }, { signal });

        // Close dropdown menus when clicking anywhere outside them
        document.addEventListener('click', (event) => {
          this.closeDropdowns(event.target);
        }, { signal });

        // matchMedia fires once at the breakpoint, unlike a resize listener
        window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
          if (event.matches) this.closeDrawer();
        }, { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        if (this.drawer?.classList.contains('is-open')) {
          document.body.style.overflow = this.previousBodyOverflow || '';
        }
      }

      openDrawer() {
        if (!this.drawer || !this.overlay) return;

        this.previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        this.drawer.classList.add('is-open');
        this.overlay.classList.add('is-visible');
        this.menuOpenButton?.setAttribute('aria-expanded', 'true');
        this.menuCloseButton?.focus();
      }

      closeDrawer(restoreFocus = false) {
        if (!this.drawer || !this.overlay || !this.drawer.classList.contains('is-open')) return;

        this.drawer.classList.remove('is-open');
        this.overlay.classList.remove('is-visible');
        this.menuOpenButton?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = this.previousBodyOverflow || '';

        if (restoreFocus) this.menuOpenButton?.focus();
      }

      openSearch() {
        if (!this.searchPanel || !this.searchToggle) return;

        this.searchPanel.hidden = false;
        this.searchToggle.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => this.searchInput?.focus());
      }

      closeSearch() {
        if (!this.searchPanel || !this.searchToggle || this.searchPanel.hidden) return;

        this.searchPanel.hidden = true;
        this.searchToggle.setAttribute('aria-expanded', 'false');
      }

      closeDropdowns(exceptWithin) {
        this.header.querySelectorAll('.elvezen-header__navigation details[open]').forEach((dropdown) => {
          if (!exceptWithin || !dropdown.contains(exceptWithin)) dropdown.removeAttribute('open');
        });
      }

      // Keep Tab inside the drawer while it is open
      trapFocus(event) {
        if (!this.drawer?.classList.contains('is-open')) return;

        const focusable = Array.from(
          this.drawer.querySelectorAll('a[href], button:not([disabled]), summary')
        ).filter((element) => element.offsetParent !== null);

        if (focusable.length === 0) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('elvezen-header', ElvezenHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
